import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { lowerCase, upperFirst } from 'lodash-es'
import CollapsibleListGroup from '../CollapsibleListGroup'
import OrderRow from './OrderRow'

/**
 * @param orders {Order[]}
 * @param period
 * @param noHighlight
 * @param openByDefault
 * @return {JSX.Element}
 */
export default function OrdersGroup({ orders, period = null, noHighlight = false, openByDefault = false }) {
  const { t } = useTranslation()
	period      = period|>lowerCase //fixes casing and spacing as well

	const header = period && t(period, { context: 'orders for...' })|>upperFirst //translations: OrdersList:ordersSorter()

  return <CollapsibleListGroup split {...{header, openByDefault}}>
    {orders.map(order => <OrderRow key={order.id} order={order} showStatus={!period} noHighlight={noHighlight}/>)}
  </CollapsibleListGroup>
}

OrdersGroup.propTypes = {
  orders       : PropTypes.array.isRequired,
  period       : PropTypes.string,
  openByDefault: PropTypes.bool,
  noHighlight  : PropTypes.bool,
}
